<template>
  <router-link
    :to="{ name: 'worker-version', params: { versionId: workerVersion.id } }"
    target="_blank"
  >
    <WorkerTypeTag :worker="workerVersion.worker" />
    {{ truncateLong(workerVersion.worker.name) }}
  </router-link>
  <br />
  <small>
    <template v-if="workerVersion.revision_url">
      <a
        :href="workerVersion.revision_url"
        target="_blank"
      >
        {{ truncateLong(workerVersion.revision_url) }}
      </a>
    </template>
    <template v-else>Version {{ workerVersion.version }}</template>
  </small>
</template>

<script lang="ts">
import { type PropType, defineComponent } from 'vue'

import { truncateMixin } from '@/mixins'
import type { WorkerVersion } from '@/types/worker'

import WorkerTypeTag from '../WorkerRuns/WorkerTypeTag.vue'

export default defineComponent({
  components: {
    WorkerTypeTag,
  },
  props: {
    workerVersion: {
      type: Object as PropType<WorkerVersion>,
      required: true,
    },
  },
  mixins: [truncateMixin],
})
</script>
